import GoogleAnalytics from './GoogleAnalytics';
import sitiosId from '../Models/SitiosId';
import LoginTypes from '../Models/LoginTypes';
import { User } from '@auth0/auth0-react';
import ModosUrl from '../Models/ModosUrl';
import { getSeccionFromUrl } from './Seccion';

const createOneTapTracking = (user, { SitioId, Modo, URLCallback }, isVerified) => {
    if (!isVerified || Modo !== ModosUrl.googleOneTap || user?.connection_type !== 'google-oauth2') return;

    const trackingUser = { is_registration: user.is_registration, connection_type: user.connection_type };
    return (profile) => trackUserHandler({ ...trackingUser, ln_user_id: profile.ln_user_id }, SitioId, Modo, URLCallback);
};

/**
 * Se almacena en el data layer el método de autenticación del usuario y sus datos asociados.
 * @param { User | undefined } user Datos del usuario autenticado
 * @param { Number } sitioId Valor único que identifica el sitio del que fue redireccionado el usuario
 * @param { String } modo Modo de ingreso al sitio (default, signwall, paywall, black, oneTap)
 * @param { String } urlCallback URL a la que será redireccionado el usuario tras el login
 */
const trackUserHandler = (user, sitioId, modo, urlCallback) => {
  if (user) {
      const origenParsed = Object.keys(sitiosId).find(key => sitiosId[key] === sitioId);
      const seccion = getSeccionFromUrl(urlCallback);
      
      const data = {
          event: !!user.is_registration ? "trackRegister" : "trackLogin",
          loginMethod: getLoginMethod(user.connection_type, modo),
          userId: user.ln_user_id,
          originId: sitioId,
          origenParsed: origenParsed,
          seccion: seccion
      }

      GoogleAnalytics.trackUser(data);
  }
};

const getLoginMethod = (connectionType, modo) => {
    const loginMethod = LoginTypes[connectionType];

    if (modo === ModosUrl.googleOneTap && loginMethod === LoginTypes['google-oauth2']) {
        return 'Google One Tap';
    }

    return loginMethod;
}

export {
    trackUserHandler,
    createOneTapTracking
}
